import { formatDateWithTimeStamp } from '../../../utils/Utils';
import styles from '../emergencyAlert.module.css';

const EmergencyAlertMetadata = ({ isEditMode, alertData, f }) => {
    const formatDate = (dateString) => {
        return !!dateString ? formatDateWithTimeStamp(dateString) : '--';
    };

    return (
        <>
            {isEditMode && (
                <>
                    <div className={`${styles.horizontalRule} mt-4 mb-4`} />
                    <div className='flex justify-content-between mb-4'>
                        <div className={styles.emergency_alert_textStyle}>
                            {f({ id: 'AI_EDU_CREATED_DATE' })}
                        </div>
                        <div className={styles.emergency_alert_textStyle}>
                            {formatDate(alertData?.createdAt)}
                        </div>
                    </div>
                    <div className='flex justify-content-between'>
                        <div className={styles.emergency_alert_textStyle}>
                            {f({ id: 'AI_EDU_UPDATED_DATE' })}
                        </div>
                        <div className={styles.emergency_alert_textStyle}>
                            {formatDate(alertData?.updatedAt)}
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default EmergencyAlertMetadata;
